export const CONTACT_EMAIL = "cristina.marketingfacile@gmail.com";
export const CONTACT_PHONE = "+393925579905";
export const CONTACT_PHONE_DISPLAY = "+39 392 557 9905";
export const LINKEDIN_URL = "https://www.linkedin.com/in/cristina-angelini-72b30031b/";
export const INSTAGRAM_URL = "https://www.instagram.com/marketingfacile_cristina";
